// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const SvgArrowThreads24 = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				width={size}
				height={size}
				viewBox="0 0 24 24"
				xmlns="http://www.w3.org/2000/svg"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M15.7991 10.1512C15.4927 9.84481 15.4691 9.36266 15.7284 9.02921L15.7991 8.94913C16.1055 8.64272 16.5877 8.61915 16.9211 8.87842L17.0012 8.94913L20.4012 12.3491C20.7076 12.6556 20.7312 13.1377 20.4719 13.4712L20.4012 13.5512L17.0012 16.9512C16.6692 17.2832 16.131 17.2832 15.7991 16.9512C15.4927 16.6448 15.4691 16.1627 15.7284 15.8292L15.7991 15.7492L17.7474 13.801L10.4464 13.8002C7.22201 13.8002 4.60873 10.1522 4.50341 6.8594L4.50011 6.65278L4.50011 6.00021L6.20011 6.00021L6.20011 6.65278C6.20011 9.05307 8.01214 11.9982 10.2675 12.0963L10.4464 12.1002L17.7474 12.101L15.7991 10.1512Z"
				/>
			</Svg>
		);
	}
);
SvgArrowThreads24.defaultProps = {
	size: 24,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default SvgArrowThreads24;
